<div id="<%= dom_id location %>" class="w-full sm:w-auto my-5 space-y-5">
  <div>
    <strong class="block font-medium mb-1">Name:</strong>
    <%= location.name %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Key:</strong>
    <%= location.key %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Region:</strong>
    <%= location.region %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Latitude:</strong>
    <%= location.latitude %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Longitude:</strong>
    <%= location.longitude %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Locale:</strong>
    <%= location.locale %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Logo:</strong>
    <%= location.logo %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Sisters:</strong>
    <%= location.sisters %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Trust level:</strong>
    <%= location.trust_level %>
  </div>
  <div>
    <strong class="block font-medium mb-1">User:</strong>
    <%= location.user_id %>
  </div>
</div>
